import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notification"
export default class extends Controller {
  hide() {
    document.getElementById('notification-panel').classList.add('hidden')
  }
}
